import { render, staticRenderFns } from "./SocialMeetingCardForFriend.vue?vue&type=template&id=53dfbdb6&scoped=true"
import script from "./SocialMeetingCardForFriend.vue?vue&type=script&lang=js"
export * from "./SocialMeetingCardForFriend.vue?vue&type=script&lang=js"
import style0 from "./SocialMeetingCardForFriend.vue?vue&type=style&index=0&id=53dfbdb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dfbdb6",
  null
  
)

export default component.exports